import React from "react";
import SelectInput from "../select/SelectInput";

const UrlDropdown = ({
    options = [],
    value,
    onChange,
}) => {
    
    const allOptions = [{ label: "All", value: "all" }, ...options,];

    return (
        <SelectInput
            options={allOptions}
            value={allOptions.find((x) => x.value === value)}
            placeholder="URL"
            onChange={onChange}
        />
    );
};

export default UrlDropdown;